export const makeAuthorizationHeader = accessToken => ({
  Authorization: `Bearer ${accessToken}`
});
